export enum PasswordResetRoutePathsEnum {
  PASSWORD_RESET = '/password-reset',
  PASSWORD_RESET_VERIFY = '/password-reset/verify',
}
